import { ReactElement } from "react";
import { SystemIcon } from "@justworkshr/milo-icons";

import styles from "./username.module.css";

const Username = ({ username }: { username: string }): ReactElement => {
  return (
    <div className={styles.username}>
      <SystemIcon size="small" iconName="person" title="username" />
      <div>{username}</div>
    </div>
  );
};

export default Username;
